import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import organizationFields from '../../fields/organizationFields';
import { ORGANIZATION } from '../apiUrls';


/**
 * @param {Object} responseData
 * @param {Object[]} responseData.items
 * @param {string} responseData.items[].uuid
 * @param {string} responseData.items[].legalName
 * @param {string} responseData.items[].businessName
 * @param {string} responseData.items[].registrationNumber
 * @param {string} responseData.items[].type
 * @param {string} responseData.items[].ports
 * @param {string} responseData.items[].createdAt
 * @param {string} responseData.items[].updatedAt
 * @param {number} responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [organizationFields.UUID.key]: item[organizationFields.UUID.key],
        [organizationFields.LEGAL_NAME.key]: item[organizationFields.LEGAL_NAME.key],
        [organizationFields.BUSINESS_NAME.key]: item[organizationFields.BUSINESS_NAME.key],
        [organizationFields.REGISTRATION_NUMBER.key]: item[organizationFields.REGISTRATION_NUMBER.key],
        [organizationFields.TYPE.key]: item[organizationFields.TYPE.key],
        [organizationFields.PORTS.key]: item[organizationFields.PORTS.key],
        [organizationFields.CREATED_AT.key]: item[organizationFields.CREATED_AT.key],
        [organizationFields.UPDATED_AT.key]: item[organizationFields.UPDATED_AT.key]
    }));

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetEnvelopesClients = ({ query, organizationId }, enabled) => {
    return {
        queryKey: [ORGANIZATION.ENVELOPES_CLIENTS.queryKey, query, organizationId],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(ORGANIZATION.ENVELOPES_CLIENTS.url, { organizationId: organizationId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetEnvelopesClients;